/**
 * #1397: a refusal because a stored copy on the server is damaged (`StoreBlobDamagedError` → 409 `CONTENT_DAMAGED`).
 * Its sentence is written for the person by `@papan/storage`'s one formatter, so every client shows it AS IT IS —
 * never a generic "failed", "unavailable" or 404 line. This is the ONE client reader of that refusal (round 6 M1:
 * surfaces kept dropping it one bare catch at a time); `no-raw-content-damaged-reads.test.ts` bans a second one.
 */
export const CONTENT_DAMAGED_CODE = 'CONTENT_DAMAGED'

/** Is this the damage refusal's wire code? For a per-item list a client words itself (`notCopied[].code`). */
export function isContentDamagedCode(code: unknown): boolean {
  return code === CONTENT_DAMAGED_CODE
}

// A sentence, never a token such as `content_damaged` (the share view and the editors send one in `error`)
const sentence = (v: unknown): string | null => (typeof v === 'string' && /\s/.test(v.trim()) ? v.trim() : null)

/**
 * The server's sentence for a `CONTENT_DAMAGED` refusal, else `null` (the caller says its own thing). Takes what a
 * client holds: a thrown `request()` error (`message` = the body's `error`, `detail` beside it), a parsed reply body
 * (`{ error, code }`), or an editor payload (`{ code, message }`).
 */
export function damagedMessageFrom(err: unknown): string | null {
  if (!err || typeof err !== 'object') return null
  const e = err as { code?: unknown; message?: unknown; error?: unknown; detail?: unknown }
  if (!isContentDamagedCode(e.code)) return null
  return sentence(e.message) ?? sentence(e.error) ?? sentence(e.detail)
}
